import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './callerIdentify.json';

const getCallerIdentifyStatus = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['CallerIdentifyController/getCallerIdentifyStatus'].success.default)));
};
const updCallerIdentifySetting = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['CallerIdentifyController/updCallerIdentifySetting'].success.default)));
};
const reportSuspiciousCall = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['CallerIdentifyController/reportSuspiciousCall'].success.default)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('CallerIdentifyController/getCallerIdentifyStatus'),
    withScenario(withAuthCheck(getCallerIdentifyStatus))
  ),
  rest.post(
    getApiEndpoint('CallerIdentifyController/updCallerIdentifySetting'),
    withScenario(withAuthCheck(updCallerIdentifySetting))
  ),
  rest.post(
    getApiEndpoint('CallerIdentifyController/reportSuspiciousCall'),
    withScenario(withAuthCheck(reportSuspiciousCall))
  ),
];
